









import { Component, Prop, Vue } from "vue-property-decorator";
import mhlogo from "../assets/mh-logo.svg";
import { Transaction } from "../store/user";
import Getter from "../store/getters";

@Component
export default class TransactionSummary extends Vue {
  @Prop() transactions!: Array<Transaction>;
  // private transactions: Array<Transaction> = [];
  private fields = [
    { key: "effective_date", label: "Date", transform: this.noop },
    { key: "credit_plan", label: "Plan #", transform: this.noop },
    { key: "reference_number", label: "Ref #", transform: this.noop },
    { key: "description", label: "Description", transform: this.noop },
    { key: "amount", label: "Amount", transform: this.format_dollars }
  ];
  noop(a: any) {
    return a;
  }
  format_dollars(value: number, negative: boolean) {
    let val = (value / 1).toFixed(2);
    val = `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    if (negative) val = "-" + val;
    return val;
  }
  created() {
    //   this.transactions = this.$store.getters[Getter.TRANSACTIONS]();
    //   console.log(this.transactions)
  }
}
